module.exports = __webpack_public_path__ + "811f461a.jpg";